import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CrisisBar } from "@/components/CrisisBar";
import { Wordmark } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";

const NAV = [["/portal", "portal.title", true], ["/portal/appointments", "portal.appointments"], ["/portal/messages", "portal.messages"], ["/portal/preferences", "portal.preferences"], ["/portal/security", "portal.security"]];

export const PortalLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { data: unread } = useQuery({ queryKey: ["messages", "unread"], queryFn: async () => (await api.get("/messages/unread")).data, refetchInterval: 60_000, enabled: !!user });
  const signOut = async () => { await logout(); navigate("/"); };
  return (
    <div className="min-h-screen flex flex-col bg-cream-50 text-ink-900">
      <a href="#main" className="sr-only-focusable fixed left-4 top-4 z-50 rounded bg-olive-900 px-4 py-3 text-cream-50">{t("nav.skip")}</a>
      <CrisisBar />
      <header className="bg-olive-900 text-cream-50" data-testid="portal-header">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-3 sm:px-6">
          <Wordmark />
          <nav aria-label="Portal" className="flex items-center gap-1 overflow-x-auto">
            {NAV.map(([to, key, end]) => (
              <NavLink key={to} to={to} end={end} className={({ isActive }) => `tap whitespace-nowrap px-3 rounded text-cream-50 hover:bg-cream-50/10 ${isActive ? "underline underline-offset-8 decoration-sage-400 decoration-2" : ""}`} data-testid={`portal-nav-${to.split("/").pop()}`}>
                {t(key)}{to === "/portal/messages" && unread?.unread > 0 && <span className="ml-1.5 inline-block min-w-[20px] rounded-full bg-terracotta-600 px-1.5 text-center text-xs font-semibold text-cream-50" data-testid="portal-nav-messages-badge">{unread.unread}</span>}
              </NavLink>
            ))}
            {user?.is_staff && <NavLink to="/staff" className="tap whitespace-nowrap px-3 rounded text-cream-50 hover:bg-cream-50/10" data-testid="portal-nav-staff">{t("nav.staffConsole")}</NavLink>}
            <button type="button" onClick={signOut} className="tap whitespace-nowrap px-3 rounded text-cream-50 hover:bg-cream-50/10" data-testid="portal-sign-out">{t("nav.signOut")}</button>
          </nav>
        </div>
      </header>
      <main id="main" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <footer className="border-t border-sage-400/50 px-4 py-6 text-sm text-ink-500 sm:px-6">
        <div className="mx-auto max-w-6xl">{t("brand.ministry")} · Front desk (909) 987-7110</div>
      </footer>
    </div>
  );
};
